import { getConfig } from '@townsquare/config';
import type { UserResponse } from '@townsquare/identity-client';

export async function remoteAuthCheck(): Promise<{
	isAuthed: boolean;
	isUnauthenticated: boolean;
	isUnauthorised: boolean;
	isNoUser: boolean;
	user: UserResponse | null;
}> {
	try {
		const authCheckPromise = await fetch(getConfig().authCheckUrl);
		const statusCode = authCheckPromise.status;
		const user = await authCheckPromise.json();

		const isUnauthenticated = statusCode === 401;
		const isUnauthorised = false; // This check gets done in the Bootstrap now
		const isAuthed = !isUnauthenticated;
		const isNoUser = false; // There's always a user now

		return {
			isAuthed,
			isUnauthenticated,
			isUnauthorised,
			isNoUser,
			user,
		};
	} catch (e) {
		return {
			isAuthed: false,
			isUnauthenticated: true,
			isUnauthorised: true,
			isNoUser: false,
			user: null,
		};
	}
}
